import { render } from "./AlterSensor.vue?vue&type=template&id=5ec4490b&scoped=true"
import script from "./AlterSensor.vue?vue&type=script&lang=js"
export * from "./AlterSensor.vue?vue&type=script&lang=js"

import "./AlterSensor.vue?vue&type=style&index=0&id=5ec4490b&lang=scss&scoped=true"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec4490b"],['__file',"src/components/sensor/AlterSensor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ec4490b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ec4490b', __exports__)) {
    console.log('reload')
    api.reload('5ec4490b', __exports__)
  }
  
  module.hot.accept("./AlterSensor.vue?vue&type=template&id=5ec4490b&scoped=true", () => {
    console.log('re-render')
    api.rerender('5ec4490b', render)
  })

}


export default __exports__